<template>
  <div>
    <transition name="slide-down-small">
      <div class="quote-error" v-if="!!quoteErrorMsg">{{ quoteErrorMsg }}</div>
    </transition>

    <div class="d-flex align-start booking-box">
      <div class="field-group">
        <!-- <label class="field-label">{{ $t('searchForm.enterPickup') }}</label> -->
        <location-input :value="pickup" :extra="pickupExtra" ref="pickup"
          :placeId="pickupPlaceId" :disabled="buttonLoading"
          :error="validation.pickup" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit"
          @focusOnNewExtra="focusOnNewExtra"
        ></location-input>
      </div>
  
      <div class="field-group" v-for="stop in extraStop.leg1" :key="stop.id">
        <!-- <label class="field-label">{{ $t('searchForm.extraStop') }}</label> -->
        <location-input :value="stop.text" :extra="stop.extra" :ref="`extraStop${stop.id}`"
          :placeId="stop.placeId" :disabled="buttonLoading"
          :error="stop.error" :id="stop.id" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit"
        ></location-input>
      </div>
  
      <div class="field-group">
        <!-- <label class="field-label">{{ $t('searchForm.enterDropoff') }}</label> -->
        <location-input :value="dropoff" :extra="dropoffExtra" ref="dropoff"
          :placeId="dropoffPlaceId" :disabled="buttonLoading"
          :error="validation.dropoff" leg="leg1"
          @change="locationNewValue" @submit="triggerClickSubmit" 
        ></location-input>
      </div>
  
      <a href="#/d2dservice" @click="validateGeo($event, 'leg1')" ref="quoteBtn"
        :class="['op-btn btn-md btn-black search-submit', {'disabled':buttonLoading}]"
      >
        <span v-if="!buttonLoading">Search</span>
        <span v-else><i class="fa fa-spinner fa-spin"></i> Searching</span>
      </a>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import moment from 'moment'
import LocationInput from '../LocationInput'
import ApiQuote from '@/modules/api/quote'

export default {
  name: 'ground-form',
  components: { LocationInput },
  data () {
    return {
      pickup: '',
      dropoff: '',
      pickupText: '',
      dropoffText: '',
      pickupPlaceId: null,
      dropoffPlaceId: null,
      timezoneLoading: false,
      quotationLoading: false,
      validation: {
        pickup: '',
        extraStop: '',
        dropoff: ''
      },
      quoteErrorMsg: '',
      quoteDelay: '',
      showOnLoad: false
    }
  },
  computed: {
    rsvpData () { return this.$store.state.reservation },
    _pickup () { return this.rsvpData.leg1.pickup.title },
    _dropoff () { return this.rsvpData.leg1.dropoff.title },
    pickupExtra () {
      return {
        field: 'pickup',
        placeholder: 'Enter your pickup location e.g. Home, Airport, Office address',
        hasExtraStop: true,
        type: 'ground'
      }
    },
    dropoffExtra () {
      return {
        field: 'dropoff',
        placeholder: 'Enter your dropoff location e.g. Home, Airport, Office address', // e.g. Home, Hotel etc.
        error: this.validation.dropoff,
        type: 'ground'
      }
    },
    airlineLoading () { return this.rsvpData.airlineLoading },
    buttonLoading () { return this.timezoneLoading || this.quotationLoading || this.airlineLoading },
    extraStop () { return this.rsvpData.extraStop },
    _brandId () { return this.$store.state.brandId },
    mtech () { return this.rsvpData.mtech }
  },
  methods: {
    locationNewValue (value) {
      let self = this
      if (value.fromMap && !value.keyInput.trim()) return

      if (value.field === 'pickup') {
        self.pickupText = value.keyInput
        // this.$emit('pickupChange')
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setPickup', {
            leg: value.leg,
            value: ''
          })
        } else {
          if (!value.blurStop) {
            this.validation.pickup = ''
            if (self.extraStop[value.leg].length) {
              if (this.$refs[`extraStop${self.extraStop.leg1[0].id}`][0].focus) {
                this.$refs[`extraStop${self.extraStop.leg1[0].id}`][0].focus()
              }
            } else if (this.$refs.dropoff.focus) {
              this.$refs.dropoff.focus()
            }
          }
        }
      } else if (value.field === 'extraStop') {
        self.$store.commit('reservation/setExtraStopData', {
          leg: value.leg,
          id: value.id,
          fields: { text: value.keyInput }
        })
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setExtraStopLocationData', {
            leg: value.leg,
            id: value.id,
            value: ''
          })
        } else {
          if (!value.blurStop) {
            self.$store.commit('reservation/setExtraStopData', {
              leg: value.leg,
              id: value.id,
              fields: { error: '' }
            })
            let index = self.extraStop.leg1.findIndex(x => x.id === value.id)
            if (index === self.extraStop.leg1.length - 1) {
              if (this.$refs.dropoff.focus) {
                this.validation.extraStop = ''
                this.$refs.dropoff.focus()
              }
            } else if (index > -1) {
              if (this.$refs[`extraStop${self.extraStop.leg1[index + 1].id}`][0].focus) {
                this.$refs[`extraStop${self.extraStop.leg1[index + 1].id}`][0].focus()
              }
            }
          }
          let index = self.extraStop.leg1.findIndex(x => x.id === value.id)
          let indexLeg2 = self.extraStop.leg2.findIndex(x => x.id === value.id)
          if (index > -1 && indexLeg2 === -1) {
            self.$store.commit('reservation/prependExtraStop', {
              leg: 'leg2',
              value: self.extraStop.leg1[index]
            })
          }
        }
      } else {
        self.dropoffText = value.keyInput
        if (value.keyInput.trim() === '') {
          self.$store.commit('reservation/setDropoff', {
            leg: value.leg,
            value: ''
          })
        } else {
          this.validation.dropoff = ''
          if (self.pickupText !== '' && !value.blurStop) {
            // self.validateGeo(null, 'leg1')
            self.triggerClickSubmit()
          }
        }
      }
    },
    triggerClickSubmit () {
      if (this.$refs.quoteBtn) this.$refs.quoteBtn.click()
    },
    focusOnNewExtra () {
      if (this.extraStop.leg1.length) {
        if (this.$refs[`extraStop${this.extraStop.leg1[this.extraStop.leg1.length - 1].id}`][0].focus) {
          this.$refs[`extraStop${this.extraStop.leg1[this.extraStop.leg1.length - 1].id}`][0].focus()
        }
      }
    },
    validateGeo (event = null, leg = 'leg1') {
      if (event) event.preventDefault()
      let self = this
      self.$store.commit('other/setOtherData', {startErrorLog: true})
      // try {
      let hasError = false
      if (!self.pickupText || !self.dropoffText) {
        if (!self.pickupText || self.pickupText.trim() === '') {
          self.validation.pickup = this.$t('common.fieldEmpty')
        }
        if (!self.dropoffText || self.dropoffText.trim() === '') {
          self.validation.dropoff = this.$t('common.fieldEmpty')
        }
        hasError = true
      }
      self.extraStop.leg1.forEach(stop => {
        if (!stop.text) {
          self.$store.commit('reservation/setExtraStopData', {
            leg: leg,
            id: stop.id,
            fields: { error: this.$t('common.fieldEmpty') }
          })
          hasError = true
        }
      })
      if (hasError) { return }

      setTimeout(function () {
        self.quotationLoading = true
        let promises = []
        // Validate pickup location geocode
        promises.push(
          new Promise((resolve, reject) => {
            if (self.rsvpData.leg1.pickup.title !== self.pickupText) {
              self.$once('pickupChange', function () { clearTimeout(timeout); resolve(); })
              let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
              self.geocode(self.pickupText.trim(), 'pickup', geocodeResult => {
                if (geocodeResult) {
                  self.pickupPlaceId = geocodeResult.place_id
                } else {
                  reject(new Error(self.$t('searchForm.manualPickup')))
                }
              })
            } else {
              resolve()
            }
          }).catch(err => {
            self.validation.pickup = self.$t('searchForm.unablePinpointPickup')
            if (!self.pickupText || self.pickupText.trim() === '') {
              self.validation.pickup = self.$t('common.fieldEmpty')
            }
            return Promise.reject(err)
          })
        )
        self.extraStop.leg1.forEach(stop => {
          promises.push(
            // Validate Extra Stop location geocode
            new Promise((resolve, reject) => {
              if (stop.location.title !== stop.text) {
                self.$once('extraStopChange', function () { clearTimeout(timeout); resolve(); })
                let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
                self.geocode(stop.text.trim(), 'extraStop', geocodeResult => {
                  if (geocodeResult) {
                    self.$store.commit('reservation/setExtraStopData', {
                      leg: 'leg1',
                      id: stop.id,
                      fields: { placeId: geocodeResult.place_id }
                    })
                  } else {
                    reject(new Error(self.$t('searchForm.manualLocation')))
                  }
                })
              } else {
                resolve()
              }
            }).catch(err => {
              let msg = self.$t('searchForm.unablePinpointExtra')
              if (!stop.text || stop.text.trim() === '') {
                msg = self.$t('common.fieldEmpty')
              }
              self.$store.commit('reservation/setExtraStopData', {
                leg: 'leg1',
                id: stop.id,
                fields: { error: msg }
              })
              return Promise.reject(err)
            })
          )
        })
        promises.push(
          // Validate dropoff location geocode
          new Promise((resolve, reject) => {
            if (self.rsvpData.leg1.dropoff.title !== self.dropoffText) {
              self.$once('dropoffChange', function () { clearTimeout(timeout); resolve(); })
              let timeout = setTimeout(function () { reject(new Error('Timeout')) }, 5000)
              self.geocode(self.dropoffText.trim(), 'dropoff', geocodeResult => {
                if (geocodeResult) {
                  self.dropoffPlaceId = geocodeResult.placeId
                } else {
                  reject(new Error(self.$t('searchForm.manualDropoff')))
                }
              })
            } else {
              resolve()
            }
          }).catch(err => {
            self.validation.dropoff = self.$t('searchForm.unablePinpointDropoff')
            if (!self.dropoffText || self.dropoffText.trim() === '') {
              self.validation.dropoff = self.$t('common.fieldEmpty')
            }
            return Promise.reject(err)
          })
        )
        Promise.all(promises)
          .then(function () {
            if (self.quoteDelay) { clearTimeout(self.quoteDelay) }
            self.quoteDelay = setTimeout(function () {
              self.submit()
            }, 500)
          })
          .catch(err => {
            self.quotationLoading = false
            console.log(err)
          })
      }, 200)
    },
    geocode (addressStr, field, callback) {
      let self = this
      const restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]
      let suggestedLoc = { lat: 33.942791, lng: -118.410042 } // LAX
      let pickup = self.$store.state.reservation.leg1.pickup
      if (['extraStop', 'droff'].indexOf(field) > -1 && pickup.lat) {
        suggestedLoc = { lat: pickup.lat, lng: pickup.lng }
      }

      let url = 'https://discover.search.hereapi.com/v1/discover?at={AT}&q={SEARCH}&apiKey={API_KEY}'
      url = url.replace('{AT}', encodeURIComponent(suggestedLoc.lat + ',' + suggestedLoc.lng))
        .replace('{SEARCH}', addressStr)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || !body.items || body.items.length === 0) { // eslint-disable-line no-undef
          return false
        }

        let result = []
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: '',
              icon: 'fa-map-marker'
            })
          }
        })

        if (!result.length) {
          return false
        } else {
          let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}'
          url = url.replace('{LOCATION_ID}', result[0].id)
            .replace('{API_KEY}', CONFIG.hereApi.key)
          request.get({
            url: url,
            json: true
          }, function (err, res, body) {
            if (err) { return false }
            callback(body)
          })
        }
      })
    },
    submit () {
      // validator
      let self = this

      self.validation.pickup = ''
      self.validation.extraStop = ''
      self.validation.dropoff = ''
      let hasError = false
      if (self.pickupText.trim() === '') {
        hasError = true
        this.validation.pickup = self.$t('common.fieldEmpty')
      }
      self.extraStop.leg1.forEach(stop => {
        if (stop.text.trim() === '') {
          hasError = true
          self.$store.commit('reservation/setExtraStopData', {
            leg: 'leg1',
            id: stop.id,
            fields: { error: self.$t('common.fieldEmpty') }
          })
        }
      })
      if (self.dropoffText.trim() === '') {
        hasError = true
        self.validation.dropoff = self.$t('common.fieldEmpty')
      }

      if (hasError) {
        self.quotationLoading = false
        return
      }

      this.timezoneLoading = true
      let url = 'https://revgeocode.search.hereapi.com/v1/revgeocode?at={AT}&lang=en-US&apiKey={API_KEY}&show=tz'
      let pickup = this.rsvpData.leg1.pickup
      url = url.replace('{AT}', encodeURIComponent(pickup.lat + ',' + pickup.lng))
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        // Default to LA
        self.$store.commit('reservation/setTimezone', { leg: 'leg1', value: 'America/Los_Angeles' })
        if (err) { console.log(err) }
        self.timezoneLoading = false
        if (body.items.length) {
          self.$store.commit('reservation/setTimezone', {leg: 'leg1', value: body.items[0].timeZone.name})
        } else {
          console.log('Zero results on GET TIMEZONE')
        }
      })

      let pickupDate = this.rsvpData.leg1.pickupDate || this.rsvpData.leg1.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        date: pickupDate,
        leg: 'leg1',
        brandId: self.$store.state.brandId,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        asap: false
      }

      self.quotationLoading = true
      self.quoteErrorMsg = ''
      quoteData = {
        brandId: self.$store.state.brandId,
        leg: 'leg1',
        pickupDate: pickupDate,
        pickup: {
          lat: self.rsvpData.leg1.pickup.lat,
          lng: self.rsvpData.leg1.pickup.lng
        },
        dropoff: {
          lat: self.rsvpData.leg1.dropoff.lat,
          lng: self.rsvpData.leg1.dropoff.lng
        },
        order: 'priority',
        asap: false
      }
      quoteData.pickup = self.rsvpData.leg1.pickup
      quoteData.dropoff = self.rsvpData.leg1.dropoff
      self.extraStop.leg1.forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })

      ApiQuote.getQuote2(self, quoteData, res => {
        self.quotationLoading = false
        if (!res.error) {
          if (
            (!res.services.length && !res.mtech && !res.lyft) ||
            (res.mtech && !res.mtech.services.length) ||
            (res.lyft && !res.lyft.length)
          ) {
            self.quoteErrorMsg = self.$t('searchForm.noAvailableService')
            return
          }
          if (res.mtech && self.extraStop.leg1.length) {
            self.quoteErrorMsg = self.$t('searchForm.serviceNA')
            return
          }
          if (!res.lyft) {
            if (res.geofences.pickup.type === 'airport' || res.geofences.dropoff.type === 'airport') {
              self.getAirlineList()
            }
            if (res.geofences.dropoff.type === 'airport') {
              self.$store.commit('reservation/setIsAirportPickup', {
                leg: 'leg2',
                value: true
              })
            }
          }

          self.$store.commit('reservation/resetServiceEta')

          let serviceExist = false
          for (let service in res.services) {
            let serviceData = res.services[service]
            if (parseInt(self.rsvpData.leg1.selectedService.substr(1)) === serviceData.serviceType.id && !serviceData.unavailableTime) {
              serviceExist = true
            }
          }
          if (!serviceExist) {
            self.$store.commit('reservation/setSelectedService', {
              leg: 'leg1',
              value: ''
            })
          }

          if (self.mtech.enabled && self.rsvpData.leg1.selectedService) {
            self.getQuoteMtechService()
          }

          if (self.showOnLoad) {
            document.body.classList.add('widget-full')
          }

          self.$store.commit('reservation/setOtherData', {bookingType: 'ground'})
          self.$root.$router.push('service')
          window.location.href = '#/service'
        } else {
          self.quoteErrorMsg = res.error.message
          if (res.error.message === 'Services unavailable') {
            self.quoteErrorMsg = self.$t('searchForm.sorryService')
          }
        }
      })
    },
    getQuoteMtechService () {
      let self = this
      let rsvpData = this.rsvpData.leg1

      let pickupDate = rsvpData.flightDate || rsvpData.pickupDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY hh:mmA')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY hh:mmA')
      let quoteData = {
        asap: false,
        brandId: self._brandId,
        leg: 'leg1',
        pickupDate: pickupDate.format('YYYY-MM-DD'),
        pickupTime: pickupDate.format('HH:mm:ss'),
        pickup: rsvpData.pickup,
        dropoff: rsvpData.dropoff,
        order: 'priority',
        passengers: rsvpData.passenger,
        mtechServiceType: rsvpData.selectedService
      }
      quoteData.pickup.text = quoteData.pickup.title
      quoteData.dropoff.text = quoteData.dropoff.title
      if (rsvpData.flightDate) {
        quoteData.pickupTimestamp = moment.tz(rsvpData.flightDate, 'MM/DD/YYYY hh:mmA', rsvpData.timezone).format('X')
      } else {
        quoteData.pickupTimestamp = moment.tz(`${quoteData.pickupDate} ${quoteData.pickupTime}`, 'YYYY-MM-DD HH:mm', rsvpData.timezone).format('X')
      }

      self.$store.commit('reservation/setServiceLoading', true)
      let timeNow = moment()
      self.$sdk.post(self, '/quotation', quoteData, res => {
        self.sendQuoteTime(timeNow, moment(), res.quoteId, quoteData)
        self.$store.commit('reservation/setServiceLoading', false)
        if (!res.error) {
          self.$store.commit('reservation/setQuoteId', res.quoteId)
          if (res.mtech.services.length) {
            let mtech = res.mtech
            let mtechStore = self.rsvpData.mtech
            let service = res.mtech.services[0]
            let price = service.price

            let hasDiscount = false
            let discountVal = 0
            let totalBeforeDc = 0
            let baseFare = price.amount
            service.price.breakdown.forEach(x => {
              if (x.description === 'Base rate') {
                baseFare = x.amount
              }
              if (x.description === 'Discount') {
                hasDiscount = true
                discountVal = x.amount
              }
              if (x.amount > 0) {
                totalBeforeDc += x.amount
              }
            })

            let addMarkup = 0
            if (mtech.markup.value) {
              addMarkup = mtechStore.markup.value
              if (mtech.markup.type === '%') {
                addMarkup = baseFare * (mtech.markup.value / 100)
              }
              addMarkup = parseFloat(addMarkup.toFixed(2))
            }

            self.$store.commit('reservation/setMtechNewPricing', {
              code: rsvpData.selectedService,
              val: {
                baseFare: baseFare,
                amount: price.amount,
                addMarkup: addMarkup,
                breakdown: price.breakdown,
                hasDiscount: hasDiscount,
                discountVal: Math.abs(discountVal),
                totalBeforeDc: totalBeforeDc
              }
            })
          }
          self.$nextTick().then(() => {
            self.$forceUpdate()
          })
        }
      }, '2.0')
    },
    checkShowOnLoad () {
      if (!this._brandId) { return }
      let brandData = Object.values(CONFIG.Brands).find((v) => {
        return parseInt(this._brandId, 10) === parseInt(v.id, 10)
      }) || false
      let firstPage = ['Search', 'SearchEdit', 'SearchTrack']
      document.body.classList.remove('widget-full')
      if (brandData) {
        this.showOnLoad = brandData.showOnLoad && firstPage.indexOf(this.route) > -1 ? 'show-on-load' : ''
      }
      if (!this.showOnLoad) {
        this.$refs.pickup.focus()
      }
    },
    getAirlineList () {
      let self = this

      let pickup = self.rsvpData.leg1.pickup
      let dropoff = self.rsvpData.leg1.dropoff
      if (typeof pickup.geofenceType === 'undefined' ||
        (pickup.geofenceType !== 'airport' && dropoff.geofenceType !== 'airport')
      ) { return }

      if (self.airlineLoading || self.rsvpData.airlineGID === pickup.geofenceId) { return }
      self.$store.commit('reservation/setAirlineLoading', true)

      let geofenceId = pickup.geofenceId
      if (pickup.geofenceType !== 'airport' && dropoff.geofenceType === 'airport') { geofenceId = dropoff.geofenceId }
      self.$sdk.get(self, '/geofences/' + geofenceId + '/airlines', {}, res => {
        self.$store.commit('reservation/setAirlineLoading', false)
        if (!res.error) {
          let airlines = []
          res.list.forEach(function (data) {
            airlines.push({
              code: data.code,
              name: data.name,
              label: '(' + data.code + ') ' + data.name
            })
          })
          self.$store.commit('reservation/setAirlineList', {
            id: geofenceId,
            list: airlines
          })
        }
      }, '/1.1')
    },
    sendQuoteTime (start, end, quoteId, param) {
      let self = this
      let store = self.$store.state
      let duration = end.diff(start, 'milliseconds') / 1000
      self.$sdk.opt('/quotation/time', {
        token: store.user.token,
        brandId: store.brandId,
        quotationId: quoteId,
        responseTime: duration,
        deviceType: 'ww',
        data: JSON.stringify(param)
      }, res => {
        if (res.error) console.log('ERROR quotation time')
      })
    },
    forceGround () {
      this.pickup = this.rsvpData.leg1.pickup.title
      this.pickupText = this.rsvpData.leg1.pickup.title
      this.dropoff = this.rsvpData.leg1.dropoff.title
      this.dropoffText = this.rsvpData.leg1.dropoff.title
      this.submit()
    }
  },
  watch: {
    _pickup: function (value) {
      this.pickupText = value
      this.$emit('pickupChange')
    },
    _dropoff: function (value) {
      this.dropoffText = value
      this.$emit('dropoffChange')
    },
    _brandId: function () {
      this.checkShowOnLoad()
    }
  },
  created () {
  },
  mounted () {
    if (this.rsvpData.leg1.pickup.title) {
      this.pickup = this.rsvpData.leg1.pickup.title
      this.pickupText = this.rsvpData.leg1.pickup.title
      this.dropoff = this.rsvpData.leg1.dropoff.title
      this.dropoffText = this.rsvpData.leg1.dropoff.title
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-box{
  gap: 10px;
}
.field-group{
  width: 100%;
}
.search-submit{
  width: 120px;
  min-width: 120px;
  text-align: center;
}
.quote-error {
  padding: 2px 0 !important;
  margin: 0 0 10px !important;
  text-align: center;
  background: #eb5837;
  color: #fff!important;
}

@media only screen and (max-width: 641px) {
  .booking-box{
    flex-direction: column;
    gap: 0px;

    .field-group, .search-submit{
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7e2a84e8